import { DatePipe } from '@angular/common';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import { EntityModification } from '@wizeoo/akm-message-lib';

/** encapsulation d'un EM pour rendu */
export class EmVO {
  /**
   * Le VO source provenant du back
   */
  private _source: EntityModification;

  constructor(pSource: EntityModification) {
    this._source = pSource;
    this.feed();
  }

  /** la classe de l'objet manipulé (premier objet) */
  public get class(): number {
    return this._source.entityClass;
  }
  /** le user à l'origine de la modif */
  public get login(): string {
    return this._source.login;
  }

  public get domain(): string {
    return this._source.domain;
  }

  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }


  public get refCode(): string {
    return this._source.refCode;
  }

  public get refField(): string {
    return this._source.refField;
  }

  public get operation(): string {
    return this._source.operation;
  }

  public get emTime(): number {
    return this._source.emTime;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** alimentation des champs composites */
  private feed(): void {
    // détail de l'opération
    this.content = 'TODO'; // this.refField + ': ' + this.oldValuej + ' => ' + this.newValue;

    // auteur et date
    let resAD: string = '';
    const date: Date = WizDateUtils.stringToTime(this.emTime.toString());
    if (date) {
      resAD = new DatePipe('en').transform(date, 'MMM d, y, h:mm:ss a'); // TODO WizDateUtils.getLocale()
    }
    resAD += ' by ' + this.login;
    this.authorAndDate = resAD;
  }

  /** création d'un contenu intelligible pour le contenu de l'EM */
  public content: string = 'content';

  /** auteur et date */
  public authorAndDate: string = 'date';
}
